import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import { selectBoosterDraft } from '@backrs_ui/grow-ui/src/redux/satActBooster/satActBooster.slice';
import { ReportFacts } from '@backrs_ui/grow-ui/src/redux/satActBooster/satActBooster.types';

import { useReportFactsAgentContext } from './hooks/useReportFactsAgentContext';
import { StepKey } from './utils/stepNavigation';

const STRINGS = appStrings.modules.satActBooster;

/** Registers the current wizard step, known intake fields, and (once computed) the report facts. */
export const useAgentContext = (step: StepKey, reportFacts: ReportFacts | null) => {
  const draft = useAppSelector(selectBoosterDraft);

  useRegisterAgentContext({
    kind: 'form',
    description:
      'ACT/SAT Test Booster wizard: the student fills an intake form, then enters scores and goals to generate a personalized study plan. Intake asks an authed student only which tests they have taken, plus a first name when the user record lacks one; expected graduation year, program start year, zip, and own school are asked of guests only. Steps: intake, score input (section scores + reporting-category subscores), score report, targets (goal, schools, schedule).',
    data: {
      currentStep: STRINGS.steps[step],
      knownIntakeFields: {
        firstName: draft.firstName || undefined,
        expectedGraduationYear: draft.expectedGraduationYear ?? undefined,
        programStartYear: draft.programStartYear ?? undefined,
        zip: draft.zip || undefined,
        school: draft.school || undefined,
        whichTests: draft.whichTests ?? undefined,
      },
    },
  });

  useReportFactsAgentContext(reportFacts);
};
